import axios from 'axios'
import { Message } from 'element-ui'
const service = axios.create({// 创建axios实例
    baseURL: IPCONFIG, // 配置baseurl,url = base url + request url    process.env.VUE_APP_BASE_API------IPCONFIG
    timeout: 10000,

})
service.interceptors.request.use( // 拦截request
    config => {
        return config
    },
    error => {
      console.log(error) // for debug
      return Promise.reject(error)
    }
)
service.interceptors.response.use(// 拦截response
    response => {
      const res = response.data
      console.log('-----------------------拦截', response)
      // 上传图片
      if(res.errno == 0){
        return res;
      }
      if (res.code != 200) {
        Message({
          message: res.msg || 'error',
          type: 'error',
          duration: 3 * 1000
        })
       
        return Promise.reject(res.msg || 'error')
      } else {
        return res
      }
    }

)
export default service
